import {
  Component,
  ChangeDetectionStrategy,
  input,
  model,
  effect,
  signal,
  computed,
} from '@angular/core';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-tabs' instead.
 */
@Component({
  selector: 'ag1-tab',
  templateUrl: './ag1-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SentenceCasePipe],
})
export class Ag1TabComponent {
  readonly scrolledIntoView = signal(0);

  readonly tabs = input<string[]>([]);
  readonly disabledTabs = input<string[]>([]);
  readonly activeTab = model<string | undefined>(undefined);
  readonly customStyle = input<string>(undefined);
  readonly loading = input<boolean>(false);
  /** Parent may bump this to scroll the active tab into view. */
  readonly scrollIntoView = input(0);
  readonly classOverrides = input<string>('');

  readonly isInsightsTabs = computed(
    () => this.customStyle() === 'insightsTabs',
  );

  constructor() {
    effect(() => {
      const scrollIntoView = this.scrollIntoView();

      // support to allow scrolling selected tab into view (e.g. after we know a tab has been set programmatically)
      if (this.scrolledIntoView() < scrollIntoView) {
        this.scrolledIntoView.set(scrollIntoView);
        setTimeout(() => {
          const ele = document.getElementsByClassName('ag1-tab--active')[0];
          if (ele) {
            ele.scrollIntoView({ block: 'nearest', inline: 'center' });
          }
        }, 0);
      }
    });
  }

  onTabChanges(tab: string): void {
    this.activeTab.set(tab);
  }
}
